require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-immediate-public-health-response-to-contain-and-control.json") })
        }
      }, "path---en-us-project-immediate-public-health-response-to-contain-and-control");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-immediate-public-health-response-to-contain-and-control!./.cache/json/en-us-project-immediate-public-health-response-to-contain-and-control.json
// module id = 529
// module chunks = 231608221292675